import t from"styled-components";const o=t.div.withConfig({displayName:"ModalContainer",componentId:"VDS__sc-v5rd4m-0"})`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${function({zIndex:t}){return t}};
`;export{o as default};
